import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'genericDictionary',
})
export class GenericDictionaryPipe implements PipeTransform {

  transform(value: string, dictionary: Record<string, string>, notFoundText: string = 'Unknown'): string {
    return dictionary && dictionary[value] ? dictionary[value] : notFoundText;
  }

}
